module.exports = __webpack_public_path__ + "img/building95-4.5b68d635.jpg";